<template>
    <div class="relative w-full" v-click-outside="onClickOutside">
        <button
            type="button"
            v-on:click="isOpen = !isOpen"
            class="flex items-center justify-between w-full px-4 py-2 font-medium appearance-none bg-light-blue-0 focus:outline-none text-blue-1"
        >
            <span class="mr-6" v-if="selectedOption">
                {{ selectedOption.$el.innerText }}
            </span>

            <svg
                fill="none"
                class="w-4 h-4 transition-transform duration-200 origin-center transform text-blue-1"
                v-bind:class="{ 'rotate-180': isOpen }"
                viewBox="0 0 24 24"
            >
                <path
                    d="M18.885 7L12 13.799 5.115 7 3 9.093 12 18l9-8.907L18.885 7z"
                    fill="currentColor"
                />
            </svg>
        </button>

        <collapse-transition ref="dropdownMenu">
            <ul v-show="isOpen" class="absolute w-full bg-white shadow-md">
                <slot :selectOption="selectOption" />
            </ul>
        </collapse-transition>

        <input
            type="hidden"
            :name="name"
            :value="selectedOption.value"
            v-if="selectedOption"
        />
    </div>
</template>

<script>
export default {
    props: ["name"],

    data() {
        return {
            isOpen: false,
            options: [],
            selectedOption: null
        };
    },

    methods: {
        onClickOutside() {
            this.isOpen = false;
        },

        selectOption(selectedOption) {
            this.selectedOption = selectedOption;
            this.isOpen = false;

            this.$nextTick(() => {
                this.$emit("change", selectedOption.value);
            });
        }
    },

    mounted() {
        this.options = this.$refs.dropdownMenu.$children;

        this.selectedOption = this.options.find(option => option.selected);
    }
};
</script>
